import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { ExternalIntegrationTypes } from "@src/appV2/ExternalIntegrations/types";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

const externalIntegrationSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(ExternalIntegrationTypes),
  isEnabled: z.boolean(),
});

type WorkplaceExternalIntegration = z.infer<typeof externalIntegrationSchema>;

const workplaceExternalIntegrationsResponseSchema = z.object({
  data: z.array(externalIntegrationSchema),
});

interface UseGetWorkplaceExternalIntegrationsParams {
  workplaceId: string;
}

export function useGetWorkplaceExternalIntegrations(
  params: UseGetWorkplaceExternalIntegrationsParams
): UseQueryResult<WorkplaceExternalIntegration[]> {
  const { workplaceId } = params;

  return useQuery({
    queryKey: ["workplaceExternalIntegrations", workplaceId],
    queryFn: async () => {
      const response = await get({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/external-integrations`,
        responseSchema: workplaceExternalIntegrationsResponseSchema,
      });

      return response.data.data;
    },
  });
}
